/**
 * Bomet Municipal Business Database Management System
 * Copyright (c) 2024 Bett Kipngetich Nicholas
 * All rights reserved.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
